/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import Peripherals from '@appblocks/codegeneration/Peripherals';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];
    const NAME = feature.getSettingValue('NAME');
    const TEMPERATURE = feature.getSettingValue('TEMPERATURE');
    const HUMIDITY = feature.getSettingValue('HUMIDITY');
    const SDA = feature.getSettingValue('SDA');

    const peripherals = Peripherals.getPin(SDA, feature.project.device.id)?.peripherals;
    let peripheralPort = '0';
    let gpioNum: string | undefined = '0';
    if (peripherals) {
        peripheralPort = peripherals.filter(p => p.peripheralType === 'gpio')[0].peripheralPort;
        gpioNum = peripherals.filter(p => p.peripheralType === 'gpio')[0].num;
    }
    const variableName = `${NAME}_dht11_sensor`;

    // const peripherals = Peripherals.getPin(PIN, feature.project.device.id)?.peripherals;
    // let gpioNum = PIN;
    // if (peripherals) {
    //     gpioNum = peripherals.filter(p => p.peripheralType === 'gpio')[0].peripheralPort;
    // }

    blocks.push({
        location: 'GLOBAL_INCLUDES',
        blockType: BlockType.CODE,
        id: '#include <zephyr/drivers/sensor.h>',
        template: '#include <zephyr/drivers/sensor.h>',
    });

    blocks.push({
        location: 'PRJ_CONF',
        blockType: BlockType.CODE,
        id: 'CONFIG_SENSOR=y',
        template: 'CONFIG_SENSOR=y',
    });

    blocks.push({
        location: 'VARIABLE_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `const struct device *const ${variableName} = DEVICE_DT_GET(DT_NODELABEL(${NAME}));`,
    });

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
if (!device_is_ready(${variableName})) {
    printk("Device %s is not ready\\n", ${variableName}->name);
    return 0;
} else {
    printk("Device %s is ready\\n", ${variableName}->name);
}`,
    });

    blocks.push({
        location: 'APP_OVERLAY_DTS',
        blockType: BlockType.CODE,
        template: `
${NAME}:${NAME} {
    compatible = "aosong,dht";
    status = "okay";
    dio-gpios = <&${peripheralPort} ${gpioNum} (GPIO_PULL_UP | GPIO_ACTIVE_LOW)>;
};`,
    });

    blocks.push({
        location: `var_${TEMPERATURE}_update`,
        blockType: BlockType.CODE,
        template: `
int rc = sensor_sample_fetch(${variableName});
int tryCount = 0;
while (rc != 0 && tryCount < 10) {
    rc = sensor_sample_fetch(dht110_dht11_sensor);
    tryCount++;
}

if (rc != 0) {
    printk("Sensor fetch failed: %d\\n", rc);
    return;
}
struct sensor_value temperature;
struct sensor_value humidity;

rc = sensor_channel_get(${variableName}, SENSOR_CHAN_AMBIENT_TEMP,
            &temperature);
if (rc == 0) {
    rc = sensor_channel_get(${variableName}, SENSOR_CHAN_HUMIDITY,
                &humidity);
}
if (rc != 0) {
    LOG_INF("get failed: %d\\n", rc);
    return;
}


LOG_INF("%.1f C ; %.1f %%RH\\n",
        sensor_value_to_double(&temperature),
        sensor_value_to_double(&humidity));


float tmp = (float)sensor_value_to_double(&temperature);
var_${TEMPERATURE}_set(tmp);
tmp = (float)sensor_value_to_double(&humidity);
var_${HUMIDITY}_set(tmp);

`,
    });

    return blocks;
};
